import classNames from 'classnames';
import { useContext } from 'react';

import { Skeleton, SkeletonProps } from '../../skeleton';
import TableContext from '../table/table-context';

export interface TableCellProps {
  className?: string;
  size?: 'small' | 'medium' | 'xs'; // will also be passed from `Table` component via `TableContext`
  align?: 'inherit' | 'left' | 'right' | 'center' | 'justify';
  loading?: boolean;
  SkeletonProps?: SkeletonProps;
  colSpan?: number;
}

export function TableCell({
  className,
  children,
  size: sizeProp,
  align = 'inherit',
  loading = false,
  SkeletonProps,
  colSpan,
}: React.PropsWithChildren<TableCellProps>) {
  const table = useContext(TableContext);
  const { size }: TableCellProps = {
    size: sizeProp || table?.size || 'medium',
  };

  return (
    <td
      className={classNames(
        size === 'medium' && ['px-3 py-3', 'text-xs'],
        size === 'small' && ['px-1 py-1', 'text-sm'],
        size === 'xs' && ['px-1 py-2 first:pl-4 last:pr-4', 'text-xs'],
        align === 'inherit' && '[text-align:inherit]',
        align === 'left' && 'text-left',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        align === 'justify' && 'text-justify',
        'text-white dark:text-gray-100',
        'text-left',
        className,
      )}
      colSpan={colSpan}
    >
      {loading && <Skeleton variant="text" {...SkeletonProps} />}
      {!loading && children}
    </td>
  );
}

export default TableCell;
